import React from 'react';
import { AiFillLinkedin, AiFillGithub} from 'react-icons/ai';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="flex flex-col items-center justify-end p-4    ">
    <div className='flex items-center justify-center bg-gray-500  text-white hover:bg-blue-800   border-balck h-10 mx-0 my-1 w-10 rounded-full   xl:h-12 xl:mx-0 xl:my-2 xl:w-12 ' >

<a className='h-4 w-4 xl:h-4 text-white  hover:text-gray-200 xl:w-4' href="https://www.linkedin.com/in/hassan-abdihakin/" target="_blank" rel="noopener noreferrer"><AiFillLinkedin/> </a>
</div>
    <div className='flex items-center justify-center bg-gray-500 text-white  hover:bg-blue-800 border-black  h-10 mx-0 my-1 w-10 rounded-full   xl:h-12 xl:mx-0 xl:my-2 xl:w-12'>
      <a className='h-4 w-4 text-white xl:h-4 xl:w-4  ' href="https://github.com/AbdihakinHassan" target="_blank" rel="noopener noreferrer"><AiFillGithub/> </a>
     </div>
    
    
  </div>
);

export default SocialMedia;